import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** Legado: /rique redireciona para o portal e abre o assistente flutuante. */
export const RiquePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams();
  next.set('openRique', '1');
  const prompt = searchParams.get('prompt')?.trim();
  if (prompt) next.set('prompt', prompt);
  return <Navigate to={`/portal?${next.toString()}`} replace />;
};
